import { requestToken } from "./request_method";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/general`;

class GeneralApiService {
  //Edit Enquiry Stage
  async editEnquiryStageRequest(formData) {
    try {
      let action = API_ROUTE + "/editEnquiryStage";
      const response = await requestToken.post(action, formData);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  // CategoryList
  async getCategoryList() {
    try {
      let action = API_ROUTE + "/categoryList";
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  // GET CATEGORY FIELDS
  async getCategoryFields(categoryID) {
    try {
      let action = API_ROUTE + `/categoryFields/${categoryID}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  // GET AREA ASSIGNED
  async getAreaAssignedPerson(categoryID, village) {
    try {
      let action =
        API_ROUTE + `/getAreaAssignedPerson/${categoryID}/${village}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  // GET FORMIK FORM DATA
  async getFormikFormData() {
    try {
      let action = API_ROUTE + `/getFormikFormData`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  // ADD MULTIFORM DATA
  async AddData(formData) {
    try {
      let action = API_ROUTE + "/addData";
      const response = await requestToken.post(action, formData);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  // UPDATE MULTIFORM DATA
  async updateMultiFormData(formData) {
    try {
      let action = API_ROUTE + "/updateData";
      const response = await requestToken.post(action, formData);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  // GET CUSTOMER DETAILS
  async getCustomerDetail(customerId) {
    try {
      let action = API_ROUTE + `/get-customerData/${customerId}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async getSalesData(payload) {
    try {
      let action = API_ROUTE + `/get-sales-data`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getSspList() {
    try {
      let action = API_ROUTE + `/get-ssp-list`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}

export default GeneralApiService;
